export default __webpack_public_path__ + "static/media/services_shopping.d8a9d4a5.svg";